import { forwardRef, type Ref, type SVGProps } from "react";
const IconUserFilledSVG = ({
  children,
  ...rest
}: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 32 32" ref={ref} {...rest}>{children}<path fill="currentColor" d="m22.03 17.69-2.07-.4A9.8 9.8 0 0 0 23 10.5V9.06a7 7 0 1 0-14 0v1.44a9.68 9.68 0 0 0 3 6.8c-.69.1-2.03.39-2.03.39C5.26 18.8 2 21.2 2 24v4a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2v-4c0-2.79-3.26-5.19-7.97-6.31" /></svg>;
const ForwardRef = forwardRef(IconUserFilledSVG);
ForwardRef.displayName = "IconUserFilled";
export { ForwardRef as IconUserFilled };